import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/Order',
  component: LAYOUT,
  name: 'Order',
  redirect: '/Order/index',
  meta: {
    title: '订单列表',
  },
  children: [
    {
      path: 'index',
      name: 'OrderIndex',
      meta: {
        title: '订单列表',
      },
      component: () => import('@/views/order/index'),
    },
    {
      path: 'detail',
      name: 'OrderDetail',
      meta: {
        title: '订单详情',
      },
      component: () => import('@/views/order/detail'),
    },
    {
      path: 'viewQrcode',
      name: 'ViewQrcode',
      meta: {
        title: '查看二维码',
      },
      component: () => import('@/views/order/viewQrcode'),
    },
  ],
};
